import React from "react";
import { toast } from "react-toastify";
import CustomToastContent from "../Component/CustomToast/CustomToast";
import { downloadProgress } from "./downloadProgressToast";

const defaultOptions = {
  position: "top-right",
  autoClose: 3500,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  className: "custom-themed-toast",
};

/**
 * Universal helper to render custom toasts
 */
const triggerCustomToast = (type, message, titleOrOptions, customOptions) => {
  let title = undefined;
  let options = {};

  if (typeof titleOrOptions === "string") {
    title = titleOrOptions;
    if (customOptions && typeof customOptions === "object") {
      options = customOptions;
    }
  } else if (typeof titleOrOptions === "object" && titleOrOptions !== null) {
    options = titleOrOptions;
    if (options.title) {
      title = options.title;
    }
  }

  const msgKey = typeof message === "string" ? message.trim() : JSON.stringify(message || "");
  const toastId =
    options.toastId ||
    `${type}_${title || ""}_${msgKey}`;

  // Prevent duplicate toast if already active on screen
  if (toast.isActive(toastId)) {
    return toastId;
  }

  const mergedOptions = {
    ...defaultOptions,
    toastId,
    ...options,
  };

  try {
    return toast(
      <CustomToastContent
        type={type}
        title={title}
        message={message}
        subtext={options.subtext}
      />,
      mergedOptions
    );
  } catch (err) {
    console.warn("Toast trigger warning:", err);
  }
};

export const showToast = {
  /**
   * Save Toast (for create/update/save actions)
   */
  save: (message, titleOrOptions, options) => {
    return triggerCustomToast("save", message, titleOrOptions, options);
  },

  /**
   * Delete Toast (for remove/delete actions)
   */
  delete: (message, titleOrOptions, options) => {
    return triggerCustomToast("delete", message, titleOrOptions, options);
  },

  /**
   * Download Toast (for file/pdf/excel export actions)
   */
  download: (message, titleOrOptions, options) => {
    return triggerCustomToast("download", message, titleOrOptions, options);
  },

  /**
   * Progress-enabled download toast controller
   */
  downloadProgress,

  /**
   * Success Toast (general success)
   */
  success: (message, titleOrOptions, options) => {
    return triggerCustomToast("success", message, titleOrOptions, options);
  },

  /**
   * Error Toast (for failed actions or validation errors)
   */
  error: (message, titleOrOptions, options) => {
    return triggerCustomToast("error", message, titleOrOptions, options);
  },

  /**
   * Warning Toast
   */
  warn: (message, titleOrOptions, options) => {
    return triggerCustomToast("warn", message, titleOrOptions, options);
  },
  warning: (message, titleOrOptions, options) => {
    return triggerCustomToast("warning", message, titleOrOptions, options);
  },

  /**
   * Info Toast
   */
  info: (message, titleOrOptions, options) => {
    return triggerCustomToast("info", message, titleOrOptions, options);
  },

  /**
   * Dismiss toast or all toasts
   */
  dismiss: (id) => toast.dismiss(id),
};

export { downloadProgress };
export const customToast = showToast;
export default showToast;

